import { createVNode as r, mergeProps as s } from "vue";
import a from "../node_modules/@pf-ui/pf-icon-svg/es/asn/BusinessComponentFilledStandard.js";
import i from "../components/PfIcon.js";
const e = (t, n) => {
  const o = {
    ...t,
    ...n.attrs
  };
  return r(i, s(o, {
    icon: a
  }), null);
};
e.displayName = "BusinessComponentFilledStandard";
e.inheritAttrs = !1;
export {
  e as default
};
